import React, {useEffect, useState} from "react";
import classNames from "classnames";
import styles from "./Form.module.css";
import PanelForm from "../panel/Form";
import {useSearchParams} from "react-router-dom";
import {AppApi} from "../AppApi"
import Faq from "../common/faq/Faq"
import BookingRequestDialogForm from "../bookingrequest/DialogForm";
import Button from "../common/botton/Button";
import {Dropdown} from "primereact/dropdown";
import durationImg from "./image/duration.png"
import locationImg from "./image/location.png"
import ablauf123Img from "./image/ablauf123.png"

import AUSFLUEGE_OPTIONAL from "./image/advantage/AUSFLUEGE_OPTIONAL.png"
import BESCHEINIGUNG_FUER_ARBEITGEBER from "./image/advantage/BESCHEINIGUNG_FUER_ARBEITGEBER.png"
import BILDUNGSURLAUB_ANERKANNT from "./image/advantage/BILDUNGSURLAUB_ANERKANNT.png"
import BUSINESS_FOKUS from "./image/advantage/BUSINESS_FOKUS.png"
import FLEXIBLE_STARTTERMINE from "./image/advantage/FLEXIBLE_STARTTERMINE.png"
import FREIZEITPROGRAMM from "./image/advantage/FREIZEITPROGRAMM.png"
import FUER_ANFAENGER_GEEIGNET from "./image/advantage/FUER_ANFAENGER_GEEIGNET.png"
import FUER_FORTGESCHRITTENE_GEEIGNET from "./image/advantage/FUER_FORTGESCHRITTENE_GEEIGNET.png"
import INTENSIVKURS from "./image/advantage/INTENSIVKURS.png"
import KLEINE_GRUPPEN from "./image/advantage/KLEINE_GRUPPEN.png"
import KONVERSATIONSTRAINING from "./image/advantage/KONVERSATIONSTRAINING.png"
import KREATIVANGEBOTE from "./image/advantage/KREATIVANGEBOTE.png"
import KULTURPROGRAMM from "./image/advantage/KULTURPROGRAMM.png"
import LAND_UND_KULTUR_ERLEBEN from "./image/advantage/LAND_UND_KULTUR_ERLEBEN.png"
import LEKTIONEN_PRO_WOCHE from "./image/advantage/LEKTIONEN_PRO_WOCHE.png"
import MUTTERSPRACHLICHE_LEHRKRAEFTE from "./image/advantage/MUTTERSPRACHLICHE_LEHRKRAEFTE.png"
import ONLINEUNTERRICHT_MOEGLICH from "./image/advantage/ONLINEUNTERRICHT_MOEGLICH.png"
import PRAESENZUNTERRICHT from "./image/advantage/PRAESENZUNTERRICHT.png"
import PRAXISNAHER_UNTERRICHT from "./image/advantage/PRAXISNAHER_UNTERRICHT.png"
import SPORTAKTIVITAETEN_OPTIONAL from "./image/advantage/SPORTAKTIVITAETEN_OPTIONAL.png"
import TEILNAHMEZERTIFIKAT_INKLUSIVE from "./image/advantage/TEILNAHMEZERTIFIKAT_INKLUSIVE.png"
import UNTERKUNFT_ZU_BUCHBAR from "./image/advantage/UNTERKUNFT_ZU_BUCHBAR.png"
import WOECHENTLICHER_KURSSTART from "./image/advantage/WOECHENTLICHER_KURSSTART.png"
import WORKSHOPS_UND_AKTIVITAETEN from "./image/advantage/WORKSHOPS_UND_AKTIVITAETEN.png"
import ZENTRALE_LAGE from "./image/advantage/ZENTRALE_LAGE.png"



export default function Form() {


    const [images, setImages] = useState([]);
    const [visible, setVisible] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const [trip, setTrip] = useState({
        dates: []
    });
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [advantage, setAdvantage] = useState(
        {
            AUSFLUEGE_OPTIONAL: AUSFLUEGE_OPTIONAL,
            BESCHEINIGUNG_FUER_ARBEITGEBER: BESCHEINIGUNG_FUER_ARBEITGEBER,
            BILDUNGSURLAUB_ANERKANNT: BILDUNGSURLAUB_ANERKANNT,
            BUSINESS_FOKUS: BUSINESS_FOKUS,
            FLEXIBLE_STARTTERMINE: FLEXIBLE_STARTTERMINE,
            FREIZEITPROGRAMM: FREIZEITPROGRAMM,
            FUER_ANFAENGER_GEEIGNET: FUER_ANFAENGER_GEEIGNET,
            FUER_FORTGESCHRITTENE_GEEIGNET: FUER_FORTGESCHRITTENE_GEEIGNET,
            INTENSIVKURS: INTENSIVKURS,
            KLEINE_GRUPPEN: KLEINE_GRUPPEN,
            KONVERSATIONSTRAINING: KONVERSATIONSTRAINING,
            KREATIVANGEBOTE: KREATIVANGEBOTE,
            KULTURPROGRAMM: KULTURPROGRAMM,
            LAND_UND_KULTUR_ERLEBEN: LAND_UND_KULTUR_ERLEBEN,
            LEKTIONEN_PRO_WOCHE: LEKTIONEN_PRO_WOCHE,
            MUTTERSPRACHLICHE_LEHRKRAEFTE: MUTTERSPRACHLICHE_LEHRKRAEFTE,
            ONLINEUNTERRICHT_MOEGLICH: ONLINEUNTERRICHT_MOEGLICH,
            PRAESENZUNTERRICHT: PRAESENZUNTERRICHT,
            PRAXISNAHER_UNTERRICHT: PRAXISNAHER_UNTERRICHT,
            SPORTAKTIVITAETEN_OPTIONAL: SPORTAKTIVITAETEN_OPTIONAL,
            TEILNAHMEZERTIFIKAT_INKLUSIVE: TEILNAHMEZERTIFIKAT_INKLUSIVE,
            UNTERKUNFT_ZU_BUCHBAR: UNTERKUNFT_ZU_BUCHBAR,
            WOECHENTLICHER_KURSSTART: WOECHENTLICHER_KURSSTART,
            WORKSHOPS_UND_AKTIVITAETEN: WORKSHOPS_UND_AKTIVITAETEN,
            ZENTRALE_LAGE: ZENTRALE_LAGE,

        }
    );



    useEffect(() => {
        if(searchParams != null && searchParams.get("id") != null) {
            getTrip(searchParams.get("id"), searchParams.get("appointment"))
        }
    }, [searchParams]);


    function getTrip(id, appointment) {
        let filter = null
        if(appointment != null && appointment !== "undefined" && appointment !== "null" && appointment !== ""){
           filter = {appointment: appointment}
        }
        AppApi.pub.getTrip(id, filter)
            .then(response => {
                setTrip(response.data)
                setSelectedAppointment(response.data?.extension?.relevantAppointments[0])
                response.data.extension?.images?.map(image => {
                    loadImage(image.id)
                })
            })
            .catch(console.log)
    }

    function loadImage(id) {
        AppApi.pub.getTripImages(id)
            .then(response => {
                let imageChache = images
                imageChache.push(URL.createObjectURL(response.data))
                setImages(imageChache)
            })
            .catch(console.log)
    }

    if(trip != null) {
        return (
            <div className={styles.wrapper}>
                {visible &&(
                    <BookingRequestDialogForm
                        trip={trip}
                        appointment={selectedAppointment}
                        onHide={() => setVisible(false)}/>
                )}


                {!visible && (
                    <div>
                        <h1>{trip.name}</h1>
                        <div>

                            <div style={{width: '100%', height: '340px', overflowY: 'auto', marginLeft: '-10px'}}>
                                <table>
                                    <tbody>
                                    <tr>
                                        {trip.extension?.images?.map( image =>
                                            <td><img className="m-2 shadow-2 border-round-3xl" style={{height: 300}} src={"/api/attachments/" + image.id} alt={image.filename} /></td>
                                        )}
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div>
                            <div className="grid">

                                <div className="lg:flex-order-1 lg:col-9 flex-order-2 col-12">
                                    <div className="grid" style={{marginBottom: -12}}>
                                        <div className="lg:col-4 col-6" style={{paddingRight: 3}}>
                                            <PanelForm style={{background: '#FCFFF5FF', height: 70, padding: 15, borderRadius: '1rem 0rem 0rem 0rem'}}>
                                                <div>
                                                    <img style={{height: 20}} src={durationImg}/>
                                                    <span className="pl-2 text-2xl font-semibold">Dauer</span>
                                                </div>
                                                <div className={styles.highlights}>
                                                    <span> {trip.appointmentLength} Tage</span>
                                                </div>
                                            </PanelForm>
                                        </div>
                                        <div className="lg:inline hidden col-4" style={{paddingLeft: 3, paddingRight: 3}}>
                                            <PanelForm style={{background: '#FCFFF5FF', height: 70, padding: 15, borderRadius: '0rem 0rem 0rem 0rem'}}>
                                                <div>
                                                    <img style={{height: 20}} src={locationImg}/>
                                                    <span className="pl-2 text-2xl font-semibold">Ort</span>
                                                </div>
                                                <div className={styles.highlights}>
                                                    <span>{trip.location}</span>
                                                </div>
                                            </PanelForm>
                                        </div>
                                        <div className="lg:col-4 col-6" style={{paddingLeft: 3}}>
                                            <PanelForm style={{background: '#FCFFF5FF', height: 70, padding: 15, borderRadius: '0rem 1rem 0rem 0rem'}}>
                                                <div>
                                                    <span className="pl-2 text-2xl font-semibold">Preis</span>
                                                </div>
                                                <div className={styles.highlights}>
                                                    <span>{trip.price}  {trip.currency}</span>
                                                </div>
                                            </PanelForm>
                                        </div>
                                    </div>


                                    <div className="inline lg:hidden">
                                        <PanelForm style={{background: '#FFFFFF', height: 80, padding: 15, borderRadius: '0rem 0rem 0rem 0rem'}}>
                                            <div>
                                                <img style={{height: 20}} src={locationImg}/>
                                                <span className="pl-2 text-2xl font-semibold">Ort: </span>
                                            </div>

                                            <div style={{marginTop: '-5px', padding: '0px 10px 0 0', fontSize: 20, textAlign: 'right'}}>
                                                {trip.location}
                                            </div>
                                        </PanelForm>
                                    </div>

                                    {trip.description && (
                                        <PanelForm style={{background: '#FFFFFF', padding: 15, borderRadius: '0rem 0rem 0rem 0rem'}}>
                                            <span className="pl-2 text-2xl font-semibold">Beschreibung:</span>
                                            <div style={{padding: '5px 0 0 20px'}}>
                                                <div className="p-editor-content ql-snow">
                                                    <div className={classNames("ql-editor", styles.description)} dangerouslySetInnerHTML={{ __html: trip.description }}></div>
                                                </div>
                                            </div>

                                            <div style={{padding: '5px 20px 0 20px'}}>
                                                <iframe width="" height="400"
                                                        src={trip.locationMapUrl}
                                                        srcd="https://maps.google.de/maps?hl=de&q=EEPAC%20%20Am%20Kalten%20Berg%2015%20Frankfurt+am+Main&t=&z=14&ie=utf8&iwloc=b&output=embed"
                                                        frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"
                                                        style={{height: '400px', width: '100%'}}></iframe>
                                            </div>



                                            <div className="flex flex-wrap" style={{justifyContent: 'center', padding: '30px'}}>
                                                {trip.extension.advantages.map(item => (
                                                    <div className={styles.advantages}>
                                                        <img style={{height: '75px', padding: 20}} src={advantage[item.code]} />
                                                        <div style={{fontSize: 12, fontWeight: 'bold'}}>{item.label}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        </PanelForm>
                                    )}

                                    {trip.descriptionOverview && (
                                        <PanelForm style={{background: '#FCFFF5FF', padding: 15, borderRadius: '0rem'}}>
                                            <span className="pl-2 text-2xl font-semibold">Auf einen Blick:</span>
                                            <div style={{padding: '5px 0 0 20px'}}>
                                                <div className="p-editor-content ql-snow">
                                                    <div className={classNames("ql-editor", styles.description)} dangerouslySetInnerHTML={{ __html: trip.descriptionOverview }}></div>
                                                </div>
                                            </div>
                                            <center>

                                                {selectedAppointment && (
                                                    <Button style={{width: '200px'}}  label="Jetzt anfragen!" onClick={() => setVisible(true)}/>
                                                )}
                                            </center>
                                        </PanelForm>
                                    )}

                                    {trip.descriptionDailyRoutine && (
                                        <PanelForm style={{background: '#FFFFFF', padding: 15, borderRadius: '0rem'}}>
                                            <span className="pl-2 text-2xl font-semibold">Tagesablauf (Beispiel):</span>
                                            <div style={{padding: '5px 0 0 20px'}}>
                                                <div className="p-editor-content ql-snow">
                                                    <div className={classNames("ql-editor", styles.description)} dangerouslySetInnerHTML={{ __html: trip.descriptionDailyRoutine }}></div>
                                                </div>
                                            </div>
                                        </PanelForm>
                                    )}

                                    {trip.descriptionActivities && (
                                        <PanelForm style={{background: '#FFFFFF', padding: 15, borderRadius: '0rem 0rem 1rem 1rem'}}>
                                            <span className="pl-2 text-2xl font-semibold">Aktivitätenprogramm:</span>
                                            <div style={{padding: '5px 0 0 20px'}}>
                                                <div className="p-editor-content ql-snow">
                                                    <div className={classNames("ql-editor", styles.description)} dangerouslySetInnerHTML={{ __html: trip.descriptionActivities }}></div>
                                                </div>
                                            </div>
                                        </PanelForm>
                                    )}

                                    <img style={{width: '100%'}} src={ablauf123Img}/>
                                    <Faq items={[
                                        {
                                            question: "Wie läuft die Anfrage ab?",
                                            answer: (
                                                <div>
                                                    Sie wählen einen Termin aus und senden Ihre Anfrage über unsere Website. Anschließend prüfen wir die Verfügbarkeit mit dem Anbieter. Wenn ein Platz verfügbar ist, erhalten Sie von uns eine Rückmeldung per E-Mail mit den nächsten Schritten.
                                                </div>
                                            )
                                        },
                                        {
                                            question: "Was muss ich meinem Arbeitgeber schicken?",
                                            answer: (
                                                <div>
                                                    Für den Antrag beim Arbeitgeber benötigen Sie in der Regel die Kursinformationen mit Termin, Ort und Unterrichtsumfang. Je nach Bundesland kann zusätzlich ein Anerkennungsnachweis erforderlich sein. Die passenden Unterlagen erhalten Sie nach der Anfrage.
                                                </div>
                                            )
                                        },
                                        {
                                            question: "Wann bekomme ich eine Rückmeldung?",
                                            answer: (
                                                <div>
                                                    Wir melden uns so schnell wie möglich per E-Mail bei Ihnen zurück, sobald die Verfügbarkeit geprüft wurde.
                                                </div>
                                            )
                                        },
                                        {
                                            question: "Buche ich direkt bei bildungs-urlaub.com?",
                                            answer: (
                                                <div>
                                                    Nein, die verbindliche Buchung erfolgt direkt beim Anbieter. Wir leiten Ihre Anfrage weiter und begleiten den Ablauf bis zur Rückmeldung.
                                                </div>
                                            )
                                        }
                                    ]}/>


                                </div>
                                <div className="lg:flex-order-2 lg:col-3 flex-order-1 col-12">
                                    <PanelForm style={{background: '#FFFFFF', padding: 15, borderRadius: '1rem 1rem 0rem 0rem'}}>
                                        <span className="pl-2 text-2xl font-semibold">Termin auswählen: </span>
                                        <div className="pt-4">
                                            <Dropdown
                                                style={{width: '100%', borderRadius: '8px'}}
                                                value={selectedAppointment}
                                                invalid={selectedAppointment == null}
                                                onChange={(e) => setSelectedAppointment(e.value)}
                                                options={trip.extension?.relevantAppointments}
                                                optionLabel="label"
                                                className="w-full" />
                                        </div>

                                        {!selectedAppointment && (
                                            <div style={{color: 'red'}}>*bitte Termin Auswählen</div>
                                        )}
                                        {selectedAppointment && (
                                            <div>
                                                <div className="pt-4">
                                                    <Button label="Verfügbarkeit anfragen" onClick={() => setVisible(true)}/>
                                                </div>
                                                <div className="pt-4">
                                                    Nutze den "Anfragen" Knopf, um die Verfügbarkeit zu prüfen. Wir antworten i.d.R. innerhalb eines Werktages.
                                                </div>
                                            </div>
                                        )}
                                    </PanelForm>


                                    <PanelForm style={{background: '#FFFFFF', padding: 15, borderRadius: '0rem'}}>
                                        <span className="pl-2 text-2xl font-semibold">Nächste Termine: </span>
                                        <div style={{padding: '5px 0 0 30px'}}>
                                            <ui style={{listStyleType: 'none'}}>
                                                {trip.extension?.relevantAppointments.slice(1, 4).map(appointment => (
                                                    <li><b style={{paddingRight: 5, color: '#86b850'}}>&#10003; </b>{appointment.untilLabel}</li>
                                                ))}
                                            </ui>
                                        </div>
                                    </PanelForm>




                                    <PanelForm style={{background: '#FFFFFF', padding: 15, borderRadius: '0rem 0rem 1rem 1rem'}}>

                                        <div className="pl-2 text-2xl font-semibold">Anerkannt in:</div>
                                        <div style={{padding: '5px 0 0 30px'}}>
                                            <ui style={{listStyleType: 'none'}}>
                                                {trip.extension?.recognizedStates?.map( state => (
                                                    <li><b style={{paddingRight: 5, color: '#86b850'}}>&#10003; </b>{state.label}</li>
                                                ))}
                                            </ui>
                                        </div>
                                    </PanelForm>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        )
    } else {
        return (
            <div className="wrapper">
                <PanelForm>
                    wird geladen
                </PanelForm>
            </div>
        )
    }
}